
class RebuySection extends HTMLElement {
    constructor() {
        super();
        this.flkty = null;
        this.amountCards = this.dataset.amount;
        this.arrayHandles = [];
        this.arrayHandlesCart = [];
        this.showSlider = this.dataset.slider;
    }


    connectedCallback() {
        // Call necessary functions to fetch and display recommended products
        this.fetchCart();
    }

    fetchCart() {
        // Fetch cart data
        fetch(`/cart.js`)
            .then((response) => response.json())
            .then((data) => this.createArrayCartItems(data))
            .catch((err) => console.error("Failed to fetch cart:", err));
    }

    createArrayCartItems(data) {
        this.arrayHandlesCart = data.items.map((item) => item.handle);
        this.fetchRebuyProducts();
    }

    fetchRebuyProducts() {
        fetch(this.dataset.url)
            .then((response) => response.json())
            .then((data) => this.createCards(data))
            .catch((err) => {
                console.error("Failed to fetch recommended products:", err)
                if (this.dataset.selector) {
                    document.querySelector(this.dataset.selector).remove()
                } else {
                    this.remove();
                }
            });
    }

    createCards(data) {
        this.arrayHandles = data.data.map((item) => item.handle);
        if (this.arrayHandles.length > 0) {
            const requests = this.arrayHandles.map((handle) => this.fetchProductCardHTML(handle));
            Promise.all(requests)
                .then((responses) => {
                    // Get the parent element where cards will be appended
                    const rebuySectionList = this.querySelector("ul");

                    // Loop through each response to create and append the card elements
                    responses.forEach((item) => {
                        if (item) {
                            const cardWrapper = document.createElement("li");
                            cardWrapper.classList.add("card-wrapper", "rebuy-list-item");
                            cardWrapper.innerHTML = item;
                            rebuySectionList.appendChild(cardWrapper);
                        }
                    });

                    // Initialize Flickity carousel if necessary
                    if (responses.length > 0 && this.showSlider == "true") {
                        this.initFlickity();
                    }
                })
                .catch((err) => console.error("Failed to fetch product cards:", err));
        } else {
            this.dataset.selector ? document.querySelector(this.dataset.selector).remove() : this.remove();
        }
    }

    initFlickity() {
        // Initialize Flickity carousel
        const options = {
            cellAlign: "left",
            contain: false,
            wrapAround: false,
            cellAlign: 'left',
            percentPosition: false
        };

        if (!this.flkty) {
            this.flkty = new Flickity(this.querySelector("ul"), options);
        } else {
            this.flkty.reloadCells();
        }

        // Additional adjustments based on the number of cards
        const flickitySlider = this.querySelector(".flickity-slider");
        if (flickitySlider.childNodes.length === 1) {
            this.querySelector(".previous").remove();
            this.querySelector(".next").remove();
            this.querySelector(".flickity-page-dots").remove();
            this.querySelector(".complementary-slide > ul").style.marginRight = "0";
            this.querySelector(".card-wrapper").style.maxWidth = "unset";
        } else if (flickitySlider.childNodes.length === 0) {
            this.remove();
        }
    }

    fetchProductCardHTML(handle) {
        // Fetch product card HTML
        if (this.amountCards < 1 || this.arrayHandlesCart.includes(handle)) return
        this.amountCards--;

        const url = `/products/${handle}?view=card`;

        return fetch(url)
            .then((res) => res.text())
            .then((text) => {
                const parser = new DOMParser();
                const htmlDocument = parser.parseFromString(text, "text/html");
                const productCardWrapper = document.createElement("li");
                const productCard = htmlDocument.documentElement.querySelector(".card-wrapper");

                if (productCard) {
                    productCardWrapper.appendChild(productCard);
                    return productCardWrapper.outerHTML;
                } else {
                    console.error(`Product card not found for handle: ${handle}`);
                    return "";
                }
            })
            .catch((err) => {
                console.error(`Failed to load content for handle: ${handle}`, err);
                return "";
            });
    }
}

// Define the custom element
customElements.define("rebuy-section", RebuySection);
